let dataUploadPicture = [];

function uploadPicture() {
	const pictures = $('[data-upload-picture="image"]');

	$.each(pictures, function () {
		let data = {};

		data.picture = $(this);

		if (data.picture.attr('data-upload-picture-model') == undefined) {
			console.error('uploadPicture > attribute "data-upload-picture-model" is undefined');
			return false;
		}

		data.picture_model = data.picture.attr('data-upload-picture-model');
		data.picture_input = $(`#${data.picture_model}`);
	
		data.picture_input.on('change', function () {
			const objectURL = URL.createObjectURL(this.files[0]);
			data.picture.attr('src', objectURL);
			setUploadPicture(data.picture_model, this.files[0]);
		});
	});
}

function setUploadPicture(id, image) {
	dataUploadPicture[id] = image;
}

function getUploadPicture(id) {
	return dataUploadPicture[id];
}